import { Checkbox } from 'primereact/checkbox'
import { Controller } from 'react-hook-form'

export const CheckboxForm = ({ control }: any) => {
  return (
    <>
      <Controller
        name="rememberMe"
        control={control}
        render={({ field }) => (
          <Checkbox
            {...field}
            checked={field.value}
          />
        )}
      />
    </>
  )
}

